var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { center: !_vm.isAllowed, grow: "" } },
    [
      _vm.isAllowed
        ? _c(
            "w-col",
            { attrs: { md: "6", xs: "12" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("price-rules")))]),
                  _c(
                    "w-list",
                    [
                      _vm.contact.PriceRules.length == 0
                        ? _c(
                            "w-list-item",
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("common.empty-list"))),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._l(_vm.contact.PriceRules, function (item) {
                        return _c(
                          "w-list-item",
                          { key: item.key },
                          [
                            _c("w-list-item-text", [
                              _vm._v(_vm._s(item.toString())),
                            ]),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c("app-missing-module", { attrs: { "module-id": _vm.moduleId } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }